<nz-tabset
  [nzAnimated]="false"
  [nzSelectedIndex]="selectedTabIndex">
  <nz-tab
    *ngFor="let tab of tabs"
    [nzTitle]="tab.title">
    <ng-container *ngTemplateOutlet="tab.contentTemplate"></ng-container>
  </nz-tab>
</nz-tabset>
